
/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import ModalContainer from '../../../frilans-finans/modal/modal-container';

export class InvoiceToolSelectVacationInformationModal extends React.Component {

  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired
  };

  render () {
    if (this.props.isOpen) {
      return (
        <ModalContainer
          isOpen
          callback={this.props.toggleModal}
          title='MODAL_VACATION_INFORMATION_TITLE'
          classes='complete-information-modal'
        >
          <div className='modal-information-container'>
            <div className='input-row-container'>
              <Translate content='MODAL_VACATION_INFORMATION_BODY' className='invoicing-description' />
            </div>
          </div>
        </ModalContainer >
      );
    } else {
      return null;
    }
  }
}

export default InvoiceToolSelectVacationInformationModal;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/complete-information-modal/invoice-tool-select-vacation-information-modal.js
 **/